<template>
	<div class="arrayMultiLineShow">
		<div class="text" v-for="(item, index) in scope.row[tableData.bind]" :key="index">
			<span>{{ getArrayValue(item) }}</span>
			<ig-icon
				:class="disabled ? 'disabled icon' : 'icon'"
				:name="tableData.iconName || 'chakan'"
				v-if="tableData.iconName"
				@click="preview(item)"
			></ig-icon>
		</div>
	</div>
</template>

<script>
export default {
	name: 'arrayMultiLineShow',
	props: ['tableData', 'scope'],
	components: {},
	data() {
		return {};
	},
	computed: {
		disabled(self) {
			if (typeof self.tableData.iconDisabled === 'function') {
				return self.tableData.iconDisabled(self.scope.row);
			}
			return self.tableData.iconDisabled;
		},
	},
	watch: {},
	mounted() {},
	methods: {
		preview(item) {

			if (!this.disabled) this.tableData.preview && this.tableData.preview(item, this.scope.row);
		},
		getArrayValue(val) {
			let { scope, tableData } = this;
			return tableData.dataStyle(val, scope.row);
		},
	},
};
</script>

<style lang="scss" scoped>
.arrayMultiLineShow {
	.text {
		display: flex;
		align-items: center;

		.icon {
			&:hover {
				color: #3da1ff;
			}
			cursor: pointer;
			margin-left: 5px;
		}

		.disabled {
			color: #c0c4cc !important;
			cursor: not-allowed;
		}
	}
}
</style>
